(() => {
  if (customElements.get("slider-reviews")) {
    return;
  }

  class sliderReviews extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest("section");

      this.slider = null;
      this.options = {
        slidesPerView: 1,
        grabCursor: true,
        spaceBetween: 20,
        autoHeight: true,
        navigation: {
          prevEl: this.section.querySelector("[data-arrow-prev]"),
          nextEl: this.section.querySelector("[data-arrow-next]"),
        },
        pagination: {
          el: this.section.querySelector("[data-pagination]"),
          clickable: true,
          renderBullet: function (index, className) {
            return `<span class="swiper-pagination-bullet"><small data-progress-bar class="swiper-pagination__progress-bar"></small></span>`;
          },
        },
        breakpoints: {
          768: {
            slidesPerView: 1
          },
          1024: {
            slidesPerView: this.dataset.perView,
          }
        },
      };

      if (this.dataset.autoplay === "true") {
        this.options.autoplay = {
          delay: this.dataset.autoplayInterval,
          disableOnInteraction: false,
        };
      }
    }

    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.initSlider();
      };

      new IntersectionObserver(handleIntersection.bind(this), {
        rootMargin: "0px 0px 200px 0px",
      }).observe(this);
    }

    initSlider() {
      this.slider = new Swiper(this, this.options);
    }
  }

  customElements.define("slider-reviews", sliderReviews);
})();
